import { type AppState, type Selector } from '../rootReducer';
import { type machineState } from './types';

export const getStates: Selector<machineState> = (state: AppState) => state.machine;
